export default __webpack_public_path__ + "static/media/sort-icon.ac5abc63.svg";